module.exports = __webpack_public_path__ + "img/settings.e7033806.svg";